import {classes} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'
import {state} from '@bitstillery/mithril'
import {Icon} from '@bitstillery/common/components'
import {current_account_slug} from '@bitstillery/common/lib/account'
import {$s, $t, notifier, store} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

export class PanelLeft extends MithrilComponent {
    className: string = ''
    logo_path: string = ''
    data = state(
        {
            betaClicker: 0,
        },
        'panel-left-data',
    )

    slot_menu() {
        throw new Error('panel left menu slot not implemented')
    }

    slot_toggles() {
        throw new Error('panel left toggles slot not implemented')
    }

    view(_: m.Vnode) {
        return (
            <div
                className={classes('c-panel-left', 'panel', this.className, {
                    collapsed: $s.panels.left.collapsed || ['mobile', 'tablet'].includes($s.env.layout),
                })}
            >
                <div className='logo'>
                    <a href='/'>
                        {(() => {
                            let logo_path
                            if (process.env.MSI_PACKAGE === 'discover') {
                                logo_path = `/theme/img/discover/${current_account_slug()}-logo`
                            } else {
                                logo_path = '/theme/img/logo'
                            }
                            return [
                                <img src={`${logo_path}-simple.png`} class='collapsed' />,
                                <img src={`${logo_path}.png`} class='collapse' />,
                            ]
                        })()}
                    </a>

                    <Icon
                        className='version'
                        name='info'
                        size='s'
                        onclick={() => {
                            this.data.betaClicker += 1
                            if (this.data.betaClicker % 7 === 0) {
                                $s.settings.beta = !$s.settings.beta
                                notifier.notify($t(`settings.beta.${$s.settings.beta ? 'active' : 'inactive'}`), 'info')
                                void store.save()
                            }
                        }}
                        tip={() => `Made with ♥️ by <a href="https://bitstillery.com" target="_blank">
                            Bitstillery</a><br/>
                            Version ${process.env.MSI_VERSION}-${process.env.BUN_ENV.slice(0, 3)} (${$s.settings.beta ? 'beta' : 'stable'})`}
                        tip_attrs={{delay: [2000, 200], interactive: true, placement: 'right'}}
                    />
                </div>

                {this.slot_menu()}
                <div className='toggles'>{this.slot_toggles()}</div>
            </div>
        )
    }
}
